import styled from "styled-components";

export const LabelPartialitie = styled.label`
  &:after {
    content: " ";
  }
`;
